<template>
  <TheDashboard :user="user">
    <template #logout-btn>
      <ClientLogoutBtn />
    </template>
    <template #sidebar="{ vOnNavigate, vOnClose, ...attrs }">
      <DashboardDailyOpportunitySidebar
        v-bind="attrs"
        :is-admin="isAdmin"
        @navigate="vOnNavigate"
        @close="vOnClose"
      />
    </template>
    <slot />
  </TheDashboard>
</template>

<script lang="ts" setup>
  // Types
  import type { TAuthStore } from '~/modules/auth/store/types';
  import type { TUser } from '~/misc/auth/types';

  // Store
  import { useAuthStore } from '~/modules/auth/store';

  // Services
  import { AuthAccess } from '~/misc/auth/services/access';

  // Components
  import TheDashboard from '~/modules/dashboard/TheDashboard.vue';
  import ClientLogoutBtn from '~/modules/auth/client-logout-btn/ClientLogoutBtn.vue';
  import DashboardDailyOpportunitySidebar from '~/modules/dashboard/daily-opportunity/sidebar/DashboardDailyOpportunitySidebar.vue';

  const authStore: TAuthStore = useAuthStore();

  const user: ComputedRef<TUser | null> = computed<TUser | null>(() => authStore.user);

  const isAdmin: ComputedRef<boolean> = computed<boolean>(
    () => !!user.value && AuthAccess.canAdministrate(user.value)
  );
</script>
